import { FC } from "react"
import { TravelersRequestDelete } from "../../../module/travelers/containers/requestDelete"

export const TravelersRequestDeletePage: FC = () => <TravelersRequestDelete />
